import { NgClass } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { SharedModule } from 'primeng/api'
import { ButtonModule } from 'primeng/button'
import { DividerModule } from 'primeng/divider'
import { DialogService } from 'primeng/dynamicdialog'
import { FileUpload } from 'primeng/fileupload'
import { MenuModule } from 'primeng/menu'
import { MessageModule } from 'primeng/message'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { TableModule } from 'primeng/table'
import { TabsModule } from 'primeng/tabs'

import { ConfigureFiltersModule } from '@app/components/configure-filters/configure-filters.module'
import { GenericModule } from '@app/components/generic/generic.module'
import { MetadataModule } from '@app/components/metadata/metadata.module'

import { DraftsComponent } from './drafts.component'
import { FileUploadModalComponent } from './file-upload-modal.component'

@NgModule({
  imports: [
    FormsModule,
    SharedModule,
    MenuModule,
    MessageModule,
    ProgressSpinnerModule,
    TabsModule,
    ButtonModule,
    DividerModule,
    FileUpload,
    ConfigureFiltersModule,
    TableModule,
    GenericModule,
    MetadataModule,
    NgClass,
    DraftsComponent,
    FileUploadModalComponent,
  ],
  providers: [
    DialogService,
  ],
  exports: [
    DraftsComponent,
  ],
})
export class DraftsModule {}
